import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../../../Button'
import { QA_NAME_OVERVIEW_COMMUNICATION_READ } from '../RentalPortalOverviewCommunicationRow.constants'

function OverviewCommunicationReadAction({
  isThreadAddressable,
  onMouseDownRead,
  onOpenRead,
}) {
  const { t } = useTranslation()

  return (
    <Button.Outlined
      isGrey
      disabled={!isThreadAddressable}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_OVERVIEW_COMMUNICATION_READ}
      text={t('RentalPortal.OverviewActionReadKey')}
      tooltip={
        isThreadAddressable
          ? null
          : t('RentalPortal.OverviewThreadUnavailableKey')
      }
      onClick={onOpenRead}
      onMouseDown={onMouseDownRead}
    />
  )
}

export default OverviewCommunicationReadAction
